import theme from '../../themes/theme';

const { BarcodeScan } = theme;

const styles = {
  footer: {
    order: 0,
    flex: 1,
    alignSelf: 'stretch',
    fontSize: 'calc(0.375em + 2vmin)',
    color: BarcodeScan.HeadingFontsColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: '2000',
  },
  footerButton: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
};

export default styles;
